import type { ServiceWithCashbackFromPartnerCollection } from "./interfaces/ServiceWithCashbackFromPartnerCollection.interface";

/** 
  @description The cashback returned to bonusx from partners (institutions, etc.) upon completion of the procedure
*/
export function getServicesCashbackPartnerCollection(): ServiceWithCashbackFromPartnerCollection {
  return window.__CMS_PRODUCT_WITH_CASHBACK_COLLECTION__;
}
